module.exports = __webpack_public_path__ + "static/media/FREEDOM-OF-42-iQ.21772074.png";